var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 835,
    height: 783,
    viewBox: "0 0 835 783",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_643_831",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 312,
    y: 166,
    width: 489,
    height: 577
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.291 167.146C313.291 167.146 609.397 751.671 616.948 741.739C624.5 731.807 799.981 442.842 799.981 442.842L313.291 167.146Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.366607
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_643_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.561 650.887L452.621 595.88L436.705 586.607L423.223 582.5L412.162 583.951L398.47 588.758L386.778 593.317L371.895 599.103L360.19 603.681L347.013 606.5L327.778 613.54L309.818 605.198L307.752 571.765L321.898 439.846L345.005 242.585L368.09 232.203L405.983 258.364L558.107 344.242L658.099 401.901L663.422 432.438L594.997 600.842L561.561 650.887Z",
    fill: "#03B853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.53 636.86L357.66 234.231L653.332 394.237L670.868 419.46L579.765 637.02L575.839 646.97L564.622 643.597L567.53 636.86Z",
    fill: "#03B853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.614 235.172L635.421 380.443C662.379 394.71 673.645 410.347 664.843 428.932L583.35 629.55C575.161 649.359 561.51 656.881 539.983 646.792L436.692 586.626C426.434 579.629 413.819 582.751 403.046 586.973L341.178 611.102C318.697 618.871 309.153 607.653 306.13 586.905L341.209 259.881C343.16 234.909 354.056 225.171 376.614 235.172Z",
    stroke: "black",
    strokeWidth: 21.1653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.972 643.048L355 238.082",
    stroke: "black",
    strokeWidth: 21.1653,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_643_831",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 163,
    width: 352,
    height: 579
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.148 163.908C321.148 163.908 632.213 740.611 619.748 741.145C607.283 741.679 269.847 720.903 269.847 720.903L321.148 163.908Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.366607
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_643_831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.742 643.818L593.731 522.968L595.198 504.605L599.518 491.19L607.021 482.935L618.782 474.433L629.197 467.433L642.441 458.512L652.88 451.512L662.714 442.299L679.47 430.521L682.868 411.012L656.591 390.238L540.184 326.58L365.004 232.998L343.305 246.032L343.167 292.078L326.889 466.009L317.184 581.025L339.225 602.821L516.565 642.721L576.742 643.818Z",
    fill: "#036D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.818 640.716L350.923 238.623L313.611 572.736L324.319 601.529L554.968 650.855L565.378 653.308L569.01 642.172L561.818 640.716Z",
    fill: "#036D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.88 254.726L312.502 550.157C308.837 580.436 315.25 598.61 335.535 601.987L546.787 649.537C567.727 654.116 581.694 647.196 585.692 623.762L595.221 504.606C595.328 492.189 605.09 483.611 614.705 477.173L669.822 440.134C689.031 426.105 685.264 411.866 669.95 397.545L381.374 239.749C359.753 227.103 345.539 230.494 340.88 254.726Z",
    stroke: "black",
    strokeWidth: 21.1653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.218 643.789L355.604 238.637",
    stroke: "black",
    strokeWidth: 21.1653,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/home-image.bf1204bd0db8bdd1d019bfa8babf0a6a.svg";
export { ForwardRef as ReactComponent };